import { atom } from 'jotai'

// Global scroll reference
export const useLocoScroll = atom(undefined)
export const useScrollNav = atom(undefined)
